export default "__VITE_ASSET__ed7540f4__"